import { render, staticRenderFns } from "./home-data-header.vue?vue&type=template&id=360c7ee0&"
import script from "./home-data-header.vue?vue&type=script&lang=ts&"
export * from "./home-data-header.vue?vue&type=script&lang=ts&"
import style0 from "./home-data-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports